// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__15RjJ","rootSuccess":"CompleteLink_rootSuccess__3A5Ip","rootFailure":"CompleteLink_rootFailure__1sTXK","isDisabled":"CompleteLink_isDisabled__WGdat"};